import React from "react";

function MoreIcon({ viewBox = "0 0 48 48", className = "" }) {
  return (
    <svg data-testid="more-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox={viewBox} className={className}>
      <g>
        <g fill="currentColor">
          <path d="M26.5 24a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"></path>
          <path d="M26.5 32a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"></path>
          <path d="M26.5 16a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"></path>
        </g>
      </g>
    </svg>
  );
}

export default MoreIcon;
